import React from "react";
import { useLocation } from "react-router-dom";

import ReportList, { Report } from "../components/Lists";

export default function Reports() {
    let query = useQuery();
    let report = query.get("report");
    let plotId = query.get("plotId");
    return (
        <div className="reports-container">
            {report ? (
                <Report report={report} plotId={plotId} />
            ) : (
                <ReportList />
            )}
        </div>
    );
}

function useQuery() {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
}
